import { render, staticRenderFns } from "./fenquduibi.vue?vue&type=template&id=51356984&scoped=true&"
import script from "./fenquduibi.vue?vue&type=script&lang=js&"
export * from "./fenquduibi.vue?vue&type=script&lang=js&"
import style0 from "./fenquduibi.vue?vue&type=style&index=0&id=51356984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51356984",
  null
  
)

export default component.exports